import React from "react"
export const ChevronDown = ({ fill, size, height, width, ...props }) => {
  return (
    <svg
      fill="none"
      height={size || height || 24}
      viewBox="0 0 24 24"
      width={size || width || 24}
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="m19.92 8.95-6.52 6.52c-.77.77-2.03.77-2.8 0L4.08 8.95"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
    </svg>
  )
}

export const ChevronRight = ({
  className,
  size,
  height,
  width,
  ...props
}: {
  className?: string
  size?: number
  height?: number
  width?: number
  [key: string]: any
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || width || 24}
      height={size || height || 24}
      viewBox="0 0 24 24"
      className={className}
      {...props}>
      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"></path>
    </svg>
  )
}

export const Lock = ({ fill, size, height, width, ...props }) => {
  const color = fill

  return (
    <svg
      height={size || height || 24}
      viewBox="0 0 24 24"
      width={size || width || 24}
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g transform="translate(3.5 2)">
        <path
          d="M9.121,6.653V4.5A4.561,4.561,0,0,0,0,4.484V6.653"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth={1.5}
          transform="translate(3.85 0.75)"
        />
        <path
          d="M.5,0V2.221"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth={1.5}
          transform="translate(7.91 12.156)"
        />
        <path
          d="M7.66,0C1.915,0,0,1.568,0,6.271s1.915,6.272,7.66,6.272,7.661-1.568,7.661-6.272S13.4,0,7.66,0Z"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth={1.5}
          transform="translate(0.75 6.824)"
        />
      </g>
    </svg>
  )
}

export const BrownLock = ({
  stroke = "hsl(20,55%,38%)",
  size,
  height,
  width,
  ...props
}: {
  stroke?: string
  size?: number
  height?: number
  width?: number
  [key: string]: any
}) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size || width || 24}
      height={size || height || 24}
      fill="none"
      stroke={stroke}
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="5" y="10" width="14" height="10" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </svg>
  )
}

export const Activity = ({ fill, size, height, width, ...props }) => {
  return (
    <svg
      height={size || height || 24}
      viewBox="0 0 24 24"
      width={size || width || 24}
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} strokeWidth={1.5}>
        <path d="M6.918 14.854l2.993-3.889 3.414 2.68 2.929-3.78" />
        <path d="M19.668 2.35a1.922 1.922 0 11-1.922 1.922 1.921 1.921 0 011.922-1.922z" />
        <path d="M20.756 9.269a20.809 20.809 0 01.194 3.034c0 6.938-2.312 9.25-9.25 9.25s-9.25-2.312-9.25-9.25 2.313-9.25 9.25-9.25a20.931 20.931 0 012.983.187" />
      </g>
    </svg>
  )
}

export const Flash = ({ fill = "currentColor", size, height, width, ...props }) => {
  return (
    <svg
      fill="none"
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M6.09 13.28h3.09v7.2c0 1.68.91 2.02 2.02.76l7.57-8.6c.93-1.05.54-1.92-.87-1.92h-3.09v-7.2c0-1.68-.91-2.02-2.02-.76l-7.57 8.6c-.92 1.06-.53 1.92.87 1.92Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
    </svg>
  )
}

export const Server = ({ fill = "currentColor", size, height, width, ...props }) => {
  return (
    <svg
      fill="none"
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M19.32 10H4.69c-1.48 0-2.68-1.21-2.68-2.68V4.69c0-1.48 1.21-2.68 2.68-2.68h14.63C20.8 2.01 22 3.22 22 4.69v2.63C22 8.79 20.79 10 19.32 10ZM19.32 22H4.69c-1.48 0-2.68-1.21-2.68-2.68v-2.63c0-1.48 1.21-2.68 2.68-2.68h14.63c1.48 0 2.68 1.21 2.68 2.68v2.63c0 1.47-1.21 2.68-2.68 2.68ZM6 5v2M10 5v2M6 17v2M10 17v2M14 6h4M14 18h4"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  )
}

export const TagUser = ({ fill = "currentColor", size, height, width, ...props }) => {
  return (
    <svg
      fill="none"
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M18 18.86h-.76c-.8 0-1.56.31-2.12.87l-1.71 1.69c-.78.77-2.05.77-2.83 0l-1.71-1.69c-.56-.56-1.33-.87-2.12-.87H6c-1.66 0-3-1.33-3-2.97V4.98c0-1.64 1.34-2.97 3-2.97h12c1.66 0 3 1.33 3 2.97v10.91c0 1.63-1.34 2.97-3 2.97Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <path
        d="M12 10a2.33 2.33 0 1 0 0-4.66A2.33 2.33 0 0 0 12 10ZM16 15.66c0-1.8-1.79-3.26-4-3.26s-4 1.46-4 3.26"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  )
}

export const Scale = ({ fill = "currentColor", size, height, width, ...props }) => {
  return (
    <svg
      fill="none"
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M9 22h6c5 0 7-2 7-7V9c0-5-2-7-7-7H9C4 2 2 4 2 9v6c0 5 2 7 7 7ZM18 6 6 18"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path d="M18 10V6h-4M6 14v4h4" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} />
    </svg>
  )
}

export const Filtering = ({ height = "1em", width = "1em", ...props }) => {
  return (
    <svg viewBox="0 0 21 21" fill="currentColor" height={height} width={width} {...props}>
      <g fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6.5 4a1 1 0 011 1v2a1 1 0 11-2 0V5a1 1 0 011-1zM18.5 6h-11M5.5 6h-3M6.5 14a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zM18.5 16h-11M5.5 16h-3M14.5 9a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zM13.5 11h-11M18.5 11h-3" />
      </g>
    </svg>
  )
}

export const LoveNote = ({ height = "1em", width = "1em", fill = "currentColor", ...props }) => {
  return (
    <svg viewBox="0 0 30 28" fill="none" height={height} width={width} {...props}>
      <path
        d="M25.3133 5.37833C24.7175 4.78217 24.0099 4.30925 23.2312 3.9866C22.4525 3.66394 21.6179 3.49787 20.775 3.49787C19.9321 3.49787 19.0975 3.66394 18.3188 3.9866C17.54 4.30925 16.8325 4.78217 16.2367 5.37833L15 6.615L13.7633 5.37833C12.5597 4.17469 10.9272 3.49849 9.225 3.49849C7.52279 3.49849 5.89031 4.17469 4.68667 5.37833C3.48303 6.58197 2.80683 8.21446 2.80683 9.91667C2.80683 11.6189 3.48303 13.2514 4.68667 14.455L15 24.7683L25.3133 14.455C25.9095 13.8591 26.3824 13.1516 26.7051 12.3729C27.0277 11.5942 27.1938 10.7596 27.1938 9.91667C27.1938 9.07376 27.0277 8.23912 26.7051 7.46042C26.3824 6.68172 25.9095 5.97422 25.3133 5.37833Z"
        fill={fill}
        stroke={fill}
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1875 19.1797C13.75 19.1536 13.3307 19.1042 12.9297 19.0312C12.5286 18.9583 12.2005 18.8854 11.9453 18.8125C11.6901 18.7344 11.5312 18.6849 11.4688 18.6641V15.8281H12.9375L13.1797 17.0312C13.2109 17.0417 13.2839 17.0729 13.3984 17.125C13.5182 17.1719 13.6797 17.2161 13.8828 17.2578C14.0859 17.2995 14.3151 17.3203 14.5703 17.3203C15.0807 17.3203 15.5052 17.2214 15.8438 17.0234C16.1875 16.8255 16.3594 16.5469 16.3594 16.1875C16.3594 15.8802 16.2214 15.638 15.9453 15.4609C15.6693 15.2839 15.2161 15.0885 14.5859 14.875C13.9453 14.651 13.4167 14.4323 13 14.2188C12.5833 14.0052 12.224 13.6901 11.9219 13.2734C11.6198 12.8568 11.4688 12.3125 11.4688 11.6406C11.4688 10.8281 11.7135 10.1667 12.2031 9.65625C12.6927 9.14583 13.3542 8.8099 14.1875 8.64844V6.75781H15.8984V8.58594C16.3047 8.61719 16.6927 8.67708 17.0625 8.76562C17.4375 8.84896 17.737 8.92969 17.9609 9.00781C18.1849 9.08594 18.3281 9.13542 18.3906 9.15625L18.3281 11.7812H16.9531L16.6484 10.6016C16.6484 10.5911 16.5 10.5495 16.2031 10.4766C15.9062 10.3984 15.6276 10.3594 15.3672 10.3594C14.8672 10.3594 14.4844 10.4531 14.2188 10.6406C13.9531 10.8281 13.8203 11.0703 13.8203 11.3672C13.8203 11.6745 13.9635 11.9193 14.25 12.1016C14.5365 12.2839 14.9896 12.4818 15.6094 12.6953C16.2604 12.9297 16.7891 13.151 17.1953 13.3594C17.6016 13.5677 17.9531 13.875 18.25 14.2812C18.5469 14.6875 18.6953 15.2031 18.6953 15.8281C18.6953 16.6927 18.4427 17.4062 17.9375 17.9688C17.4323 18.526 16.7526 18.8958 15.8984 19.0781V21.3359H14.1875V19.1797Z"
        fill="#FF3F0F"
        fill-opacity="0.97"
      />
    </svg>
  )
}

export const LoveNoteCurrency = ({ height = "1em", width = "1em", fill = "currentColor", ...props }) => {
  return (
    <svg viewBox="0 0 12 13" fill="none" height={height} width={width} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.86 2.85999C11.76 2.41999 11.54 2.01999 11.23 1.68999C10.9 1.32999 10.49 1.03999 10.04 0.839995C9.58003 0.649995 9.09003 0.549995 8.59003 0.559995C8.10003 0.569995 7.61003 0.679995 7.16003 0.889995C6.72003 1.10999 6.00003 1.55999 6.00003 1.55999C6.00003 1.55999 5.30003 1.10999 4.85003 0.889995C4.40003 0.679995 3.91003 0.569995 3.42003 0.559995C2.92003 0.549995 2.43003 0.649995 1.98003 0.839995C1.53003 1.03999 1.12003 1.31999 0.790027 1.68999C0.480027 2.01999 0.260027 2.41999 0.150027 2.85999C-0.709973 5.85999 2.12003 10.17 6.00003 12.56C9.58003 10.17 12.71 6.43999 11.86 2.85999ZM8.00003 4.55999H5.00003V5.55999H7.00003C7.55003 5.55999 8.00003 6.00999 8.00003 6.55999V7.55999C8.00003 8.10999 7.55003 8.55999 7.00003 8.55999V9.55999H5.00003V8.55999H4.00003V7.55999H7.00003V6.55999H5.00003C4.45003 6.55999 4.00003 6.10999 4.00003 5.55999V4.55999C4.00003 4.00999 4.45003 3.55999 5.00003 3.55999V2.55999H7.00003V3.55999H8.00003V4.55999Z"
        fill="white"
      />
    </svg>
  )
}

export const Kiss = ({ height = "1em", width = "1em", fill = "currentColor", ...props }) => {
  return (
    <svg viewBox="0 0 48 48" fill={fill} height={height} width={width} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill={fill}
        d="M14 22.1c3.9-.7 6.1-1.1 7.5-1.4 3-.6 2-.6 5 0 1.4.3 3.6.7 7.5 1.4 5.8 1 11.3-1.2 13.5-2.3-2.3-2.7-9.6-10.7-16.4-11.1-2.5-.2-4.6.6-6.4 2.5l-.7.7-.7-.7c-1.9-1.8-4-2.6-6.4-2.5-6.8.5-14.1 8.4-16.4 11.2 2.2 1 7.7 3.3 13.5 2.2z"></path>
      <path
        fill={fill}
        d="M33.7 24.1c-.3 0-.5-.1-.8-.1-1.3.4-6.7 2-8.9 2s-7.6-1.6-8.9-2c-.3 0-.5.1-.8.1-5.2.9-10.1-.5-13-1.7 11.1 19.2 22.3 16.8 22.4 16.7l.2-.1.2.1c.1 0 11.4 2.4 22.4-16.7-2.3.9-5.7 2-9.6 2-.9 0-2.1-.1-3.2-.3z"></path>
    </svg>
  )
}

export const Team = ({ height = "1em", width = "1em", fill = "currentColor", ...props }) => {
  return (
    <svg viewBox="0 0 24 24" fill={fill} height={height} width={width} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.3,12.22A4.92,4.92,0,0,0,14,8.5a5,5,0,0,0-10,0,4.92,4.92,0,0,0,1.7,3.72A8,8,0,0,0,1,19.5a1,1,0,0,0,2,0,6,6,0,0,1,12,0,1,1,0,0,0,2,0A8,8,0,0,0,12.3,12.22ZM9,11.5a3,3,0,1,1,3-3A3,3,0,0,1,9,11.5Zm9.74.32A5,5,0,0,0,15,3.5a1,1,0,0,0,0,2,3,3,0,0,1,3,3,3,3,0,0,1-1.5,2.59,1,1,0,0,0-.5.84,1,1,0,0,0,.45.86l.39.26.13.07a7,7,0,0,1,4,6.38,1,1,0,0,0,2,0A9,9,0,0,0,18.74,11.82Z"
        fill={fill}></path>
    </svg>
  )
}

export const User = ({ height = "1em", width = "1em", fill = "currentColor", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      id="Account"
      fill={fill}
      height={height}
      width={width}
      {...props}>
      <path
        d="M15.71,12.71a6,6,0,1,0-7.42,0,10,10,0,0,0-6.22,8.18,1,1,0,0,0,2,.22,8,8,0,0,1,15.9,0,1,1,0,0,0,1,.89h.11a1,1,0,0,0,.88-1.1A10,10,0,0,0,15.71,12.71ZM12,12a4,4,0,1,1,4-4A4,4,0,0,1,12,12Z"
        fill={fill}></path>
    </svg>
  )
}

export const ShoppingBag = ({ height = "1em", width = "1em", fill = "currentColor", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      id="bag"
      fill={fill}
      height={height}
      width={width}
      {...props}>
      <path
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="13"
        d="M61.15,35.2507,41.7257,61.15v90.649a12.95,12.95,0,0,0,12.95,12.95h90.649a12.95,12.95,0,0,0,12.95-12.95V61.15l-19.4247-25.9Z"></path>
      <line
        x1="41.726"
        x2="158.274"
        y1="61.15"
        y2="61.15"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="13"></line>
      <path
        fill="none"
        stroke="#c9430d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="13"
        d="M125.9,86.8341c0,13.8324-11.5957,25.0457-25.9,25.0457S74.1,100.6665,74.1,86.8341"></path>
    </svg>
  )
}

export const BlogIcon = ({ height = "1em", width = "1em", fill = "currentColor", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="Blog"
      fill={fill}
      height={height}
      width={width}
      {...props}>
      <path
        d="M27 10h-2V7a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v20a3 3 0 0 0 3 3h21.5a3.5 3.5 0 0 0 3.5-3.5V13a3 3 0 0 0-3-3ZM4 27V7a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1v19.5a3.45 3.45 0 0 0 .35 1.5H5a1 1 0 0 1-1-1Zm24-.5a1.5 1.5 0 0 1-3 0V12h2a1 1 0 0 1 1 1Z"
        fill={fill}></path>
      <path
        d="M20 11H10a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2zm0 5H7a1 1 0 0 0 0 2h13a1 1 0 0 0 0-2zm0 5H7a1 1 0 0 0 0 2h13a1 1 0 0 0 0-2z"
        fill={fill}></path>
    </svg>
  )
}
